export default __webpack_public_path__ + "static/media/37.4ff72cb5.jpg";